export { VideoModal } from "./videoModal";
